import { CHANGE_PRICEOM_CONFIG_REQUEST, CHANGE_PRICEOM_CONFIG_REQUEST_SUCCESS, CHANGE_PRICEOM_CONFIG_REQUEST_FAILURE } from '../constants/priceom_config.constants';

export const changePriceOMConfigRequest = (_id, config) => ({
    type: CHANGE_PRICEOM_CONFIG_REQUEST, _id, config,
});

export const changePriceOMConfigRequestSuccess = payload => ({
    type: CHANGE_PRICEOM_CONFIG_REQUEST_SUCCESS, payload,
});

export const changePriceOMConfigRequestFailure = error => ({
    type: CHANGE_PRICEOM_CONFIG_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Price-o-matic_update/redux/actions/change_priceom_config.actions.js